import React from "react";
import {
  Button,
  Card,
  CardBody,
  Container,
  Row,
  Col,
} from "reactstrap";
import { Link } from "react-router-dom";

import DemoNavbar from "components/Navbars/DemoNavbar.js";
import SimpleFooter from "components/Footers/SimpleFooter.js";
import { setPageMeta } from "utils/seo.js";

class IndustrialSolutions extends React.Component {
  componentDidMount() {
    setPageMeta({
      title: "Industrial Monitoring",
      description:
        "Connected sensors and cameras for industrial sites: equipment monitoring, environmental tracking, predictive maintenance, and real-time safety alerts.",
      path: "/industrial",
    });
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    this.refs.main.scrollTop = 0;
  }

  render() {
    return (
      <>
        <DemoNavbar />
        <main ref="main">
          <div className="position-relative">
            <section className="section section-lg section-shaped pb-250">
              <div className="shape shape-style-1 shape-chisp-industrial">
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
              </div>
              <Container className="py-lg-md d-flex">
                <div className="col px-0">
                  <Row>
                    <Col lg="6">
                      <h1 className="display-3 text-white">
                        Industrial{" "}
                        <span>Monitoring</span>
                      </h1>
                      <p className="lead text-white">
                        Comprehensive device connectivity and monitoring solutions for industrial operations. 
                        Track equipment performance, monitor environmental conditions, and optimize productivity 
                        with intelligent analytics and real-time data insights.
                      </p>
                      <div className="btn-wrapper">
                        <Button
                          className="btn-icon mb-3 mb-sm-0"
                          color="info"
                          href="#features"
                        >
                          <span className="btn-inner--icon">
                            <i className="fa fa-eye" />
                          </span>
                          <span className="btn-inner--text">
                            Explore Features
                          </span>
                        </Button>
                        <Button
                          className="btn-white btn-icon mb-3 mb-sm-0 ml-1"
                          color="default"
                          tag={Link}
                          to="/contact"
                        >
                          <span className="btn-inner--icon">
                            <i className="fa fa-envelope" />
                          </span>
                          <span className="btn-inner--text">
                            Request Demo
                          </span>
                        </Button>
                      </div>
                    </Col>
                    <Col lg="6">
                      <img
                        alt="Industrial monitoring box with construction site"
                        className="img-fluid"
                        src={require("assets/img/Box_Alarm_with_Construction_Site.JPG")}
                        style={{ maxWidth: "100%", borderRadius: "10px" }}
                      />
                    </Col>
                  </Row>
                </div>
              </Container>
            </section>
          </div>

          <section className="section section-lg pt-lg-0 mt--200" id="features">
            <Container>
              <Row className="justify-content-center">
                <Col lg="12">
                  <Row className="row-grid">
                    <Col lg="4">
                      <Card className=" shadow border-0">
                        <CardBody className="py-5">
                          <div className="icon icon-shape icon-shape-primary rounded-circle mb-4">
                            <i className="fa fa-cogs" />
                          </div>
                          <h6 className="text-primary text-uppercase">
                            Equipment Monitoring
                          </h6>
                          <p className="description mt-3">
                            Real-time monitoring of industrial equipment performance, health, and efficiency. 
                            Track machine operations, detect anomalies, and optimize maintenance schedules 
                            with intelligent sensor integration and analytics.
                          </p>
                          <div>
                            <span className="badge badge-pill badge-primary">
                              Performance Tracking
                            </span>
                            <span className="badge badge-pill badge-primary">
                              Predictive Maintenance
                            </span>
                            <span className="badge badge-pill badge-primary">
                              Efficiency Optimization
                            </span>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col lg="4">
                      <Card className=" shadow border-0">
                        <CardBody className="py-5">
                          <div className="icon icon-shape icon-shape-warning rounded-circle mb-4">
                            <i className="fa fa-thermometer-half" />
                          </div>
                          <h6 className="text-warning text-uppercase">
                            Environmental Monitoring
                          </h6>
                          <p className="description mt-3">
                            Comprehensive environmental condition monitoring for optimal operations. 
                            Track temperature, humidity, air quality, and other critical parameters 
                            to maintain ideal working conditions and prevent equipment damage.
                          </p>
                          <div>
                            <span className="badge badge-pill badge-warning">
                              Temperature Control
                            </span>
                            <span className="badge badge-pill badge-warning">
                              Air Quality Monitoring
                            </span>
                            <span className="badge badge-pill badge-warning">
                              Humidity Tracking
                            </span>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col lg="4">
                      <Card className=" shadow border-0">
                        <CardBody className="py-5">
                          <div className="icon icon-shape icon-shape-success rounded-circle mb-4">
                            <i className="fa fa-line-chart" />
                          </div>
                          <h6 className="text-success text-uppercase">
                            Predictive Analytics
                          </h6>
                          <p className="description mt-3">
                            Advanced data analytics and machine learning to predict equipment failures, 
                            optimize maintenance schedules, and improve overall operational efficiency 
                            through intelligent insights and automated recommendations.
                          </p>
                          <div>
                            <span className="badge badge-pill badge-success">
                              Failure Prediction
                            </span>
                            <span className="badge badge-pill badge-success">
                              Maintenance Optimization
                            </span>
                            <span className="badge badge-pill badge-success">
                              Cost Reduction
                            </span>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </section>

          <section className="section section-lg">
            <Container>
              <Row className="justify-content-center text-center mb-lg">
                <Col lg="8">
                  <h2 className="display-3">Industrial Monitoring Solutions</h2>
                  <p className="lead text-muted">
                    Advanced monitoring devices and analytics designed for industrial environments.
                    From construction sites to manufacturing facilities, our ruggedized solutions provide 
                    comprehensive visibility and control.
                  </p>
                </Col>
              </Row>
              <Row className="row-grid align-items-center mb-5">
                <Col md="6">
                  <img
                    alt="Industrial monitoring box side view"
                    className="img-fluid"
                    src={require("assets/img/Box_Side_View.JPG")}
                    style={{ borderRadius: "10px" }}
                  />
                </Col>
                <Col md="6">
                  <div className="pl-md-5">
                    <div className="icon icon-lg icon-shape icon-shape-primary shadow rounded-circle mb-5">
                      <i className="fa fa-microchip" />
                    </div>
                    <h3>Ruggedized Hardware</h3>
                    <p className="description mt-3">
                      Industrial-grade monitoring devices built to withstand harsh environments:
                    </p>
                    <ul className="list-unstyled mt-3">
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <div className="badge badge-circle badge-success mr-3">
                              <i className="fa fa-shield" />
                            </div>
                          </div>
                          <div>
                            <h6 className="mb-0">
                              Weatherproof and dustproof enclosures
                            </h6>
                          </div>
                        </div>
                      </li>
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <div className="badge badge-circle badge-success mr-3">
                              <i className="fa fa-thermometer-half" />
                            </div>
                          </div>
                          <div>
                            <h6 className="mb-0">
                              Operating temperature range: -20°C to +60°C
                            </h6>
                          </div>
                        </div>
                      </li>
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <div className="badge badge-circle badge-success mr-3">
                              <i className="fa fa-battery-full" />
                            </div>
                          </div>
                          <div>
                            <h6 className="mb-0">
                              Extended battery life with solar charging options
                            </h6>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </Col>
              </Row>
              <Row className="row-grid align-items-center">
                <Col md="6">
                  <div className="pr-md-5">
                    <div className="icon icon-lg icon-shape icon-shape-info shadow rounded-circle mb-5">
                      <i className="fa fa-sitemap" />
                    </div>
                    <h3>Connectivity & Integration</h3>
                    <p className="description mt-3">
                      Seamless integration with existing systems and multiple connectivity options:
                    </p>
                    <ul className="list-unstyled mt-3">
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <div className="badge badge-circle badge-info mr-3">
                              <i className="fa fa-wifi" />
                            </div>
                          </div>
                          <div>
                            <h6 className="mb-0">
                              WiFi, Ethernet, and cellular connectivity
                            </h6>
                          </div>
                        </div>
                      </li>
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <div className="badge badge-circle badge-info mr-3">
                              <i className="fa fa-plug" />
                            </div>
                          </div>
                          <div>
                            <h6 className="mb-0">
                              Standard industrial protocols (Modbus, OPC-UA)
                            </h6>
                          </div>
                        </div>
                      </li>
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <div className="badge badge-circle badge-info mr-3">
                              <i className="fa fa-cloud" />
                            </div>
                          </div>
                          <div>
                            <h6 className="mb-0">
                              Cloud and on-premises deployment options
                            </h6>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </Col>
                <Col md="6">
                  <img
                    alt="Industrial monitoring box open view"
                    className="img-fluid"
                    src={require("assets/img/Open_Box.JPG")}
                    style={{ borderRadius: "10px" }}
                  />
                </Col>
              </Row>
            </Container>
          </section>

          <section className="section section-lg bg-gradient-default">
            <Container>
              <Row className="text-center justify-content-center">
                <Col lg="10">
                  <h2 className="display-3 text-white">Optimize Your Operations</h2>
                  <p className="lead text-white">
                    Increase efficiency, reduce downtime, and improve decision-making with 
                    comprehensive industrial monitoring and analytics solutions.
                  </p>
                </Col>
              </Row>
              <Row className="row-grid mt-5">
                <Col lg="4">
                  <div className="text-center">
                    <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary mb-4">
                      <i className="fa fa-bar-chart text-primary" />
                    </div>
                    <h5 className="text-white mt-3">Performance Analytics</h5>
                    <p className="text-white mt-3">
                      Track key performance indicators, identify bottlenecks, and optimize 
                      processes with detailed analytics and reporting dashboards.
                    </p>
                  </div>
                </Col>
                <Col lg="4">
                  <div className="text-center">
                    <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary mb-4">
                      <i className="fa fa-wrench text-primary" />
                    </div>
                    <h5 className="text-white mt-3">Predictive Maintenance</h5>
                    <p className="text-white mt-3">
                      Reduce unplanned downtime and maintenance costs with AI-powered 
                      predictive analytics that forecast equipment failures before they occur.
                    </p>
                  </div>
                </Col>
                <Col lg="4">
                  <div className="text-center">
                    <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary mb-4">
                      <i className="fa fa-mobile text-primary" />
                    </div>
                    <h5 className="text-white mt-3">Mobile Accessibility</h5>
                    <p className="text-white mt-3">
                      Access real-time data and control systems from anywhere with 
                      mobile-responsive dashboards and instant alert notifications.
                    </p>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
        </main>
        <SimpleFooter />
      </>
    );
  }
}

export default IndustrialSolutions;